export const CONFIDENCE_RANK = {
  empty: 0,
  fair: 1,
  medium: 2,
  high: 3,
};

export const confidenceConfig = {
  empty: {
    label: '-',
    bg: '#ffffff',
    border: '#eeeeee',
    text: '#525252',
    dot: '#a3a3a3',
    bar: '#ff9900',
  },
  fair: {
    label: 'Fair',
    bg: '#fffbeb',
    border: '#fef3c7',
    text: '#b45309',
    dot: '#f59e0b',
    bar: '#ff9900',
  },
  medium: {
    label: 'Medium',
    bg: '#e3f0db',
    border: '#c7e1b7',
    text: '#4d7c0f',
    dot: '#73b44b',
    bar: '#73b44b',
  },
  high: {
    label: 'High',
    bg: '#673AB7',
    border: '#673AB7',
    text: '#ffffff',
    dot: '#73b44b',
    bar: '#673AB7',
  },
};
